// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5847e36f","488":"9eb05619","732":"bec50d86"}[chunkId] + ".chunk.js";
};